export default __webpack_public_path__ + "static/media/classroomImg2.47f307af.svg";